import React from 'react';
import { ShoppingCart, Laptop, Palette, UtensilsCrossed, Stethoscope, Music, Shirt, Wrench } from 'lucide-react';

const IndustriesSection = () => {
  const industries = [
    { icon: ShoppingCart, name: 'E-commerce' },
    { icon: Laptop, name: 'Technology' },
    { icon: Palette, name: 'Creative Arts' },
    { icon: UtensilsCrossed, name: 'Food & Beverage' },
    { icon: Stethoscope, name: 'Healthcare' },
    { icon: Music, name: 'Entertainment' },
    { icon: Shirt, name: 'Fashion' },
    { icon: Wrench, name: 'Manufacturing' },
  ];

  return (
    <section className="py-24 relative overflow-hidden" style={{ background: 'linear-gradient(180deg, #0D0507 0%, #1A0A0E 100%)' }}>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center max-w-3xl mx-auto mb-16">
          <p className="text-xs font-bold uppercase tracking-[0.2em] text-gold-400 mb-3">Industries We Serve</p>
          <h2 className="text-3xl sm:text-4xl font-bold tracking-tight text-white mb-4">Trademark Protection for Every Industry</h2>
          <p className="text-wine-300">From Amazon sellers to tech startups, we protect brands across all major industries.</p>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
          {industries.map((item) => (
            <div key={item.name} className="group bg-wine-900/40 border border-wine-800/40 rounded-xl p-6 text-center hover:border-gold-400 hover:bg-wine-800/50 hover:-translate-y-1 hover:shadow-lg hover:shadow-gold-500/10 transition-all duration-300">
              <div className="w-12 h-12 bg-wine-800 border border-wine-700/50 rounded-lg flex items-center justify-center mx-auto mb-3 group-hover:bg-gold-500 group-hover:border-gold-400 transition-all duration-300">
                <item.icon className="w-6 h-6 text-gold-400 group-hover:text-wine-950 transition-colors duration-300" strokeWidth={1.5} />
              </div>
              <span className="text-sm font-medium text-wine-200 group-hover:text-white transition-colors">{item.name}</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default IndustriesSection;
